<template>
    <b-list-group-item
        :href="coursePath"
        :class="`course__item ${direction} ${!availability ? 'disabled' : ''}`"
        @click.prevent="select"
    >
        <div class="row">
            <div class="col-3">
                <div class="aspectRatio">
                    <div>
                        <img class="imgFit" :src="$store.getters.getIsTrainer ? course.course_image_url : course.course_image" alt="" crossorigin="anonymous"/>
                    </div>
                </div>
            </div>
            <div class="col-9 d-flex align-middle align-items-center">
                <div>
                    <h2
                        v-if="course.name"
                        class="mb-1"
                    >
                        {{ course.name }}
                    </h2>
                    <p :class="'mb-0 ' + $store.getters.getDirection">
                        <template v-if="endDate">{{ $t('validUntil') }}: {{ endDate }}<br></template>
                        <template v-if="user.type !== 'trainer' && (course.status === 'Submitted' || course.status === 'Failed' || course.status === 'Passed')">{{ $t('submitted') }}</template>
                    </p>
                    <b-button class="course__item__dl" v-if="downloaded" @click.stop.prevent="deleteCourse()"><svg-icon icon="delete"></svg-icon></b-button>
                    <b-button class="course__item__dl" v-else-if="online && this.$store.getters.getIsTrainer" @click.stop.prevent="downloadCourse()" :disabled="processing">
                        <svg-icon v-if="!processing" icon="download"></svg-icon>
                        <b-spinner v-else small :label="$t('downloading')" style="color: var(--contrast);"></b-spinner>
                    </b-button>
                </div>
            </div>
        </div>
    </b-list-group-item>
</template>
<script>

import ReadableTime from '../common/getReadableTime';
import SvgIcon from '@/components/SvgIcon';
import CourseService from '../services/CourseService';
import Bugsnag from '@bugsnag/js';

export default {
    name: 'CourseBlock',
    props: {
        course: {
            required: true
        }
    },
    components: {
        SvgIcon
    },
    computed: {
        coursePath() {
            return this.user.type === 'trainer' ? '/courses/' + this.course.id + '/whiteboard' : '/courses/' + this.course.id;
        },
        direction(){
            if (this.course.is_rtl !== undefined){
                if (this.course.is_rtl){
                    return 'rtl';
                } else {
                    return 'ltr';
                }
            } else {
                return '';
            }
        },
        online() {
            return navigator.onLine;
        },
        endDate() {
            if (this.$store.getters.getIsTrainer || this.course.is_evergreen){
                return null;
            }
            return ReadableTime.getReadableTime(this.course.end_date);
        },
        availability() {
            if (navigator.onLine || this.downloaded){
                return true;
            }
            return false;
        }
    },
    data(){
        return {
            user: this.$store.getters.getUser,
            processing: false,
            cache: null,
            downloaded: false
        }
    },
    async created() {
        if (!this.$store.getters.getIsTrainer) {
            return;
        }
        this.cache = await caches.open('courses');
        this.downloaded = await this.cache.match(process.env.VUE_APP_APIURL + '/api/v1/course/' + this.course.id + '?cache=true') ? true : false;
    },
    methods: {
        showToast(titleKey, textKey, textArgs = []) {
            this.$bvToast.toast(this.$t(textKey, textArgs), {
                title: this.$t(titleKey),
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: 5000,
                appendToast: false,
                variant: 'primary',
                solid: true,
                id: '' + this.course.id,
            });
        },
        openCourse() {
            this.$router.push(this.coursePath);
        },
        select() {
            if (this.availability) {
                this.openCourse();
                return;
            }

            this.showToast('offlineNotDownloadedTitle', 'offlineNotDownloadedText');
        },
        async downloadCourse() {
            this.processing = true;
            try {
                await CourseService.getCourse(this.course.id, true);
                this.downloaded = true;
                this.processing = false;
                this.showToast('courseDownloadedTitle', 'courseDownloadedMessage', [this.course.name]);
            } catch(error) {
                this.processing = false;
                Bugsnag.notify(error);
            }
        },
        async deleteCourse() {
            this.processing = true;
            try {
                await CourseService.getCourse(this.course.id, 'delete');
                await this.cache.delete(process.env.VUE_APP_APIURL + '/api/v1/course/' + this.course.id + '?cache=true');
                this.downloaded = false;
                this.processing = false;
                this.showToast('courseDeletedTitle', 'courseDeletedMessage', [this.course.name]);
            } catch (error){
                this.processing = false;
                Bugsnag.notify(error);
            }
        }
    }
}

</script>
